import {
  Component,
  OnChanges,
  SimpleChanges,
  NgZone,
  PLATFORM_ID,
  Inject,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { isPlatformBrowser } from '@angular/common';

import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { ReportPropertyDetailService } from '../../residential-property/residential-property-detail.service';
import { SharedService } from 'src/app/common/services/shared.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { TranslateService } from '@ngx-translate/core';
import { countryCode } from 'src/app/common/constants/common.contants';


@Component({
  selector: 'app-build-up-info',
  templateUrl: './build-up-info.component.html',
  styleUrls: ['./build-up-info.component.scss'],
})
export class BuildUpInfoComponent implements OnChanges {

  @Input() propertyInfo: any;

  @Output() isEmpatyCheck = new EventEmitter();

  buildUpinfo: any = null;
  totalBuildUpinfo: any = null;
  isFirstTime : boolean = true;

  private root!: am5.Root;
  private legendRoot!: am5.Root;
  unitType = GlobalContants.keySymbolContants.squareMeterUnit;
  isSaudiCheck!: boolean;
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private zone: NgZone,
    private reportPropertyDetailService: ReportPropertyDetailService,
    private sharedService: SharedService,
    private translate: TranslateService
  ) {
    this.sharedService.language$.subscribe(lang => {
      if (lang && !this.isFirstTime) {
        this.getBuiltInformation();
      }
    })
  }

  ngOnInit() {
     this.isSaudiCheck = this.sharedService.getStoreValue(GlobalContants.StoreKey.countryCode) === countryCode.saudi;
        
    this.isFirstTime = false;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.root) {
      this.root.dispose();
    }
    if (this.legendRoot) {
      this.legendRoot.dispose();
    }
    this.sharedService.language$.subscribe({
      next : (res: any) => {
        this.getBuiltInformation();
      },
      error : (err:any) => { }
    })
  }

  getBuiltInformation() {

    this.reportPropertyDetailService.getBuiltInformation().subscribe(
      {
        next: (res: any) => {
          if (res.status === 200 && res.data) {
            this.buildUpinfo=[];
            let buildup: any[] = res.data.list_builtup_info;
            if(buildup?.length>0){
              buildup.sort((a: any, b: any) => (Number(a.sort_order) - Number(b.sort_order)))
              buildup.map((e) => {
                if(e.value){
                  this.buildUpinfo.push({
                    category : e.name,
                    value: e.value
                  })
                }
              });
              if(this.buildUpinfo.length>0)this.pieChart();
            }else{
              this.buildUpinfo = null;
            }
            if(res.data.total_built_up_info && Object.keys(res.data.total_built_up_info).length>0){
              this.totalBuildUpinfo = res.data.total_built_up_info;
            }else{
              this.totalBuildUpinfo = null;
            }
            const hasBuildUpInfo = 
                this.totalBuildUpinfo?.total_built_up_area || 
                this.totalBuildUpinfo?.floors || 
                this.totalBuildUpinfo?.furnishing_status || 
                this.buildUpinfo?.length;

              if (!hasBuildUpInfo) {
                this.isEmpatyCheck.next(false);
              }
           } else {
             this.isEmpatyCheck.next(false)
             this.buildUpinfo = null;
             this.totalBuildUpinfo = null;
           }

        }, error:(err)=>{
           this.isEmpatyCheck.next(false)
          this.buildUpinfo = null;
          this.totalBuildUpinfo = null;
        }
      }
    )
  }

  // Run the function only in the browser
  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }

  pieChart() {
    this.browserOnly(() => {
      if (this.root) {
        this.root.dispose();
      }
      let root = am5.Root.new('chartdiv');

      root.setThemes([am5themes_Animated.new(root)]);

      let chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          layout: root.verticalLayout,
          radius: am5.percent(80),

        })
      );

      // Define data
      var data = this.buildUpinfo;
      // Create series
      var series = chart.series.push(
        am5percent.PieSeries.new(root, {
          name: 'Series',
          valueField: 'value',
          categoryField: 'category',
          legendLabelText: "[bold]{category}[/]",
          legendValueText: "{value}" +" "+(this.translate.instant('sqm_unit')) + "[/]",
          alignLabels: false
        })
      );
      series.set("colors", am5.ColorSet.new(root, {
        colors: [
          am5.color(0xC3D5F8),
          am5.color(0x2372F0),
          am5.color(0xEE7435),
          am5.color(0x57AC52),
          am5.color(0x664FD9),
          am5.color(0x87ACF1),
        ]
      }))
      series.data.setAll(data);
      // series.labels.template.setAll({
      //   text: "[bold]{valuePercentTotal.formatNumber('0.00')}%",
      //   fontSize: 9,
      //   fill: am5.color(0xFFFFFF),
      //   radius: -60
      // });
      series.ticks.template.set('forceHidden', true);
      series.labels.template.set('forceHidden', true);
      series.slices.template.set('tooltipText', '{category}: {valuePercentTotal.formatNumber("0.00")}%');



      var legendRoot = am5.Root.new('legenddiv');

      legendRoot.setThemes([am5themes_Animated.new(root)]);

      var legend = legendRoot.container.children.push(
        am5.Legend.new(legendRoot, {
          width: am5.percent(100),
          centerX: am5.percent(50),
          x: am5.percent(50),
          layout: am5.GridLayout.new(root, {
            maxColumns: 2,
            fixedWidthGrid: true,
          }),
        })
      );
      legend.itemContainers.template.setAll({
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 5,
        paddingRight: 5,
        marginBottom: 8,
        marginRight: 8,
      });
      legend.markerRectangles.template.setAll({
        cornerRadiusTL: 10,
        cornerRadiusTR: 10,
        cornerRadiusBL: 10,
        cornerRadiusBR: 10,
      });

      legend.markers.template.setAll({
        width: 11,
        height: 11,
      });
      legend.labels.template.setAll({
        fontSize: 11,
        maxWidth: 170,
        oversizedBehavior: 'wrap',
      });
      legend.valueLabels.template.setAll({
        fontSize: 11,
      });

      legend.data.setAll(series.dataItems);


      this.root = root;
      this.legendRoot= legendRoot;
    });
  }
}
